export default "\r\n<app-service-request-list></app-service-request-list>\r\n";